export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'
export const ADULTS_COUNT_MIN = 1
export const CHILDREN_COUNT_MIN = 0
export const MAX_TRAVELLERS_COUNT = 30
